import "../css/InfoPage.css";

import {useNavigate } from "react-router-dom";

const VoucherPage = () =>{

    const navigate = useNavigate();

    const handlePageClick = (page) =>{
        navigate(page);  
    }

    const handleBookingClick = () =>{
        window.open("https://lin.ee/uNosyZb", "_blank", "noopener,noreferrer");
    }

    return(
        <div className="info-page">
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start"}}>
                <img src="/assets/navbar/gametory_icon.png" style={{height:"50px", margin:"10px"}}/>
                <div style={{height:"60px", top:"-5px", right:"-5px", position:"absolute", cursor:"pointer"}} onClick={()=>handlePageClick("/gameroom")}>
                    <img src="/assets/voucher/gameplay_button.png" style={{height:"100%"}}/>
                    <div 
                        style={{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"100%", 
                            textAlign:"center", fontSize:"18px", fontWeight:"bold"
                        }}
                    >
                        TRY GAMES
                    </div>
                </div>
            </div>
            <div 
                style={{
                    fontFamily:"IBM Plex Sans Thai", fontWeight:"600", fontSize:"30px", textAlign:"center", 
                    display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column",
                    width:"100%", marginTop:"20px", lineHeight:"36px"
                }}
            >
                ปลดปล่อยจินตนาการ<br/>ผ่านการ<br/>
                <div style={{fontSize:"50px", fontWeight:"bold", marginTop:"20px", color:"#f7914e"}}>สร้างเกม</div>
                <img src="/assets/voucher/voucher_line.png" style={{width:"250px", marginTop:"5px"}}/>
                <div style={{marginTop:"20px", position:"relative", cursor:"pointer"}} onClick={()=>handleBookingClick()}>
                    <img src="/assets/voucher/booking_btn.png" style={{width:"200px"}}/>
                    <div style={{position:"absolute", width:"200px", top:"45%", left:"50%", fontSize:"21px", fontFamily:"Lexend", transform:"translate(-50%,-50%)"}}>BOOK TIME</div>
                </div>
                <div style={{fontSize:"16px", fontWeight:"500", marginTop:"-8px"}}>อย่าลืมจองเวลาก่อนเข้าไปเล่นนะ</div>
            </div>
            <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", marginTop:"25px"}}>
                <img src="/assets/voucher/gametory_steps.png"  style={{width:"100%", maxWidth:"850px"}}/>
            </div>
            <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                <img src="/assets/voucher/gametory_hashtags.png"  style={{width:"70%", maxWidth:"600px"}}/>
            </div>
            {/*<div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", margin:"40px 0px"}}>
                <div style={{textAlign:"center", width:"80%", maxWidth:"600px", fontFamily:"IBM Plex Sans Thai", fontSize:"18px", fontWeight:"500", lineHeight:"24px"}}>
                    ความคิดสร้างสรรค์ไม่ใช่พรสวรรค์ แต่เป็นกล้ามเนื้อที่ฝึกได้ <br/>
                    ที่ Gametory เด็ก ๆ จะได้เปิดจินตนาการ เลือกเกมของตัวเอง <br/>
                    วาดตัวละครด้วยมือ ใส่เสียง และเลือกพลังวิเศษ <br/>
                    ทำให้ภาพวาดธรรมดากลายเป็นเกมที่เล่นจริง ๆ ได้!
                </div>
            </div>*/}
            <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", backgroundColor:"#cee5f7"}}>
                <img src="/assets/voucher/gametory_map.png"  style={{width:"70%", maxWidth:"600px"}}/>
            </div>
            <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", position:"relative"}}>
                <img src="/assets/voucher/review_arcade.png" style={{height:"70dvh", maxWidth:"90%", objectFit:"contain"}}/>
                <div style={{zIndex:"10", position:"absolute", textAlign:"center", top:"50%", left:"50.5%", transform:"translate(-50%,-50%)", fontSize:"31px", fontWeight:"bold"}}>
                    LET'S <br/> CREATE <br/> GAMES! 
                </div>
            </div>
            <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", backgroundColor:"black", minHeight:"200px"}}>
                <div style={{color:"white", fontSize:"24px", textAlign:"center"}}>BOOK YOUR TIME AT <span style={{color:"#359b35"}}>LINEOA: @gametory</span></div>
            </div>
        </div>
    );
}

export default VoucherPage;